import React, { useEffect, useState } from 'react'
import { useQuery } from '@apollo/client'
import { useSession } from 'packages/@slerp/accounts'
import { GET_LIGHTSPEED_STORES } from './queries'
import { LightspeedStore } from '../Manage/ManageLightspeed/types'
import { useIntegration } from '../hooks/useIntegration'
import { LoaderProps } from 'router/Loaders/types'

export const LightspeedStoresLoader = ({
  isParentLoaded = true,
  children
}: LoaderProps) => {
  const { merchant } = useSession()
  const {
    setLightspeedStores,
    setLightspeedStoresLoading,
    setRefetchLightspeedStores
  } = useIntegration()

  const [isLoaded, setIsLoaded] = useState(false)

  const { data, loading, refetch } = useQuery<{
    stores: LightspeedStore[]
  }>(GET_LIGHTSPEED_STORES, {
    skip: !merchant?.id,
    variables: { merchantId: merchant?.id }
  })

  useEffect(() => {
    if (!refetch) {
      return
    }

    const refetchAndSync = async () => {
      const result = await refetch()
      if (result.data?.stores) {
        setLightspeedStores(result.data.stores)
      }
      return result
    }

    setRefetchLightspeedStores(
      (() => refetchAndSync) as unknown as () => Promise<unknown>
    )
  }, [refetch])

  useEffect(() => {
    if (data?.stores) {
      setLightspeedStores(data.stores)
    }
  }, [data])

  useEffect(() => {
    setLightspeedStoresLoading(loading)
  }, [loading])

  useEffect(() => {
    setIsLoaded(isParentLoaded && (!merchant?.id || !loading))
  }, [loading, isParentLoaded, merchant?.id])

  return <React.Fragment>{children(isLoaded)}</React.Fragment>
}
